import React from "react";

import { pickPercent } from "./utils";
import OnePanelChart from "./OnePanelChart";
import DivFormula from "./DivFormula";
import Text from "./Text";

const GrossMargins = ({ teams, competitionMetrics }) => (
  <OnePanelChart
    vertical
    title="Gross Margins"
    suffix="%"
    data={pickPercent(teams, competitionMetrics, "Gross Margin")}
    teams={teams}
  >
    <Text>
      Gross Margins is a percentage that measures the spread between the
      revenues that you generated from selling a product with the cost of
      producing that product.
    </Text>
    <Text>
      For example, if Apple generates a total of $100 in sales from selling the
      iPhone, but it cost Apple $30 to produce the iPhone, then iPhone's gross
      margin would be 70% (i.e. $100 - $30) / $100.
    </Text>
    <DivFormula
      sm
      name1="GROSS MARGINS"
      name2="REVENUES - COST OF SALES"
      name3="REVENUES"
    />
  </OnePanelChart>
);

export default GrossMargins;



// WEBPACK FOOTER //
// ./src/components/analysis/GrossMargins.js